import React from "react";
import { Tabs, Spin } from "antd";
import { useSelector } from "react-redux";

const ModalTabs = ({ children, handleTabChange, loading = false }) => {
  const { isLoading } = useSelector((state) => state.LoaderReducer);
  return (
    <Spin spinning={isLoading || loading}>
      <div className="yandex-wrapper -mx-1">
        <Tabs
          defaultActiveKey="1"
          onChange={handleTabChange}
          className="logistic-integration-tabs"
          animated={{ inkBar: true, tabPane: false }}
        >
          {children}
        </Tabs>
      </div>
    </Spin>
  );
};

export default ModalTabs;
